/**
 * 시스템 정보 > HA 설정
 *
 * @since 2021-10-28
 * @author wj-tams-dev1
 */

export const state = () => ({
  // ## ha tabs
  // interface
  interfaceSelectedHaUuid: -1,
  // ipv4 routing
  ipv4RoutingSelectedHaUuid: -1,
  // ipv6 routing
  ipv6RoutingSelectedHaUuid: -1,
  // ipv6 transition
  tunnelingSelectedHaUuid: -1,
  // ipv6 transition
  transitionSelectedHaUuid: -1,
  // ipv6 routing
  dnsSelectedHaUuid: -1
})

export const mutations = {
  // ipv-routing
  setInterfaceSelectedHaUuid: (state, haValue) => {
    state.interfaceSelectedHaUuid = haValue
  },
  // ipv4-routing
  setIpv4RoutingSelectedHaUuid: (state, haValue) => {
    state.ipv4RoutingSelectedHaUuid = haValue
  },
  // ipv6-routing
  setIpv6RoutingSelectedHaUuid: (state, haValue) => {
    state.ipv6RoutingSelectedHaUuid = haValue
  },
  // ipv6-tunnelingSettingTabs
  setTunnelingSelectedHaUuid: (state, haValue) => {
    state.tunnelingSelectedHaUuid = haValue
  },
  // ipv6-transitionSettingTabs
  setTransitionSelectedHaUuid: (state, haValue) => {
    state.transitionSelectedHaUuid = haValue
  },
  // dns
  setDnsSelectedHaUuid: (state, haValue) => {
    state.dnsSelectedHaUuid = haValue
  }
}

export const actions = {
  // interface
  setInterfaceHaPrefix () {
  },
  // HOST interface
  setHostInterfaceHaPrefix () {
  },
  // VRI interface
  setVriInterfaceHaPrefix () {
  },
  // VWI interface
  setVwiInterfaceHaPrefix () {
  },
  // ipv4-routing
  setIpv4RoutingtHaPrefix () {
  },
  // VRI ipv4-routing
  setVriIpv4RoutingtHaPrefix () {
  },
  // ipv6-routing
  setIpv6RoutingtHaPrefix () {
  },
  // VRI ipv6-routing
  setVriIpv6RoutingtHaPrefix () {
  },
  // ipv6-tunneling
  setTunnelingHaPrefix () {
  },
  // ipv6-transition
  setTransitionHaPrefix () {
  },
  // dns
  setDnsHaPrefix ({commit, state, dispatch}, param) {
    dispatch('sm/systemConfig/dnsSettings/setHaPrefixAction', param, {root: true})
  }
}
